<template>
  <div>
     <h2 v-if="deactivated==1">Account will be deactivated after - {{expiry_date}} </h2>
    <h2 v-else-if="isGracePeriod">Grace Period End Date - {{expiry_date}} </h2>
    <h2 v-else>Plan Expiry Date - {{expiry_date}} </h2>
    <h2 v-if="deactivated == 1">Account will be deactivated after {{expiry_day}} days.</h2>
    <h2 v-else-if="payment_status == 'PAID'"></h2>
    <h2  class='expiryday-content'v-else-if="is_trail_active == 1">
      Trial Period Ends In {{expiry_day}} Days
      <p class='textColor-change header_span_text'>Pay Now & Get {{discountPercent}}% Discount!</p>
     </h2>
    <h2 v-else>Trial Period Expired</h2>
    <div class="blue-bgBtn">
    <button class="btn choose-btn bg-blue-payBtn" @click="payNow" v-if="payment_status != 'PAID'">PAY NOW</button>
  </div>
    <h2 v-if="app_status == 'grace_period'">{{grace_period_text}}</h2>
    <v-row  class="active-yearly">
      <!-- v-if="plan_type == 'yearly'" -->
      <template v-for="pricinglists in get_plan_list" >
      <v-col :key="pricinglists.id" v-if="pricinglists.is_plan_active == '1'" >
        <v-card
          class="mx-auto"
          max-width="700"
        >
        
          <v-card-text>
            <div class="plan-detailbox">
              <h3>{{pricinglists['name']}}
                <span class="plan-icon_box">
                  <v-img 
                    max-height="50"
                    max-width="50"
                    :src="logo_image+pricinglists['icon']"
                    ></v-img>
                </span>
              </h3>
              <h2><span>&#8377</span> {{pricinglists['amount']}}/yr<span class="light-weight"></span></h2>
              <ul>
                <li v-for="json_decoded_notes in pricinglists['json_decoded_notes']">{{json_decoded_notes['note']}}</li>
               <span style="margin-top:25px; font-weight: bold;color:#000;display:block;">*Condition Apply</span>
              </ul>
              <div class="choose-box">
                <button id="current_button" class="btn choose-btn active mr-2" @click="currentPlan">CURRENT PLAN ({{status}})</button>
              </div>
            </div>
          </v-card-text>
          <div class="pricingplan-bottom-box">
            <span>Cancel your plan anytime, post {{trail_days}} days Trial period.</span><br>
            <span>Refer to Subscription <a href="javascript:void(0)" class="how-work" style="color: rgb(241, 151, 0);font-size: 14px;padding-right: 10px;cursor: pointer;text-align: right;padding-bottom:5px;text-decoration: none;" @click="planDialog = !planDialog">Terms & Conditions</a></span><br>
            <v-btn class="orange-btn btn" @click="changePlan(currentplan)"> {{is_current_plan}} Subscription</v-btn>
          </div>
        </v-card>
      </v-col>
      </template>
    </v-row>

    <div class="text-center">
      <v-dialog
        v-model="planDialog"
        width="1000">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Terms & Conditions
          </v-card-title>
          <v-card-text>
            <h4 style="color:#000;">Subscription to the services of Nimeya Technologies Private Limited (Nimeya) are governed by the following terms and conditions. Nimeya is committed to provide its services for the specified period of agreement without any deviation / alternation subject to legal and regulatory guidelines of government authorities. However, the terms may be altered / amended at the sole discretion of Nimeya anytime after the agreement period which will be effective for any renewed period of service.  You are advised to read the wordings carefully for your own understanding and may seek expert advice wherever necessary.</h4>
           <ol style="margin-top:10px;">
            <li>Nimeya offers different types of subscription plans for access to its digital applications through mobile devices and computer / laptops</li>
            <li>Nimeya reserves the right to alter / amend the features, contents and types of services that it makes available for different subscription plans at any time, including without limitation to registered users. However, services already paid for will continue to be availed with the agreed features and contents during the subscription period.</li>
            <li>"By registering on the application / site you can become a registered user.</li>
            <li>As a registered user you will be entitled to use the digital application free of cost for a period of 30 days from the date of registration.</li>
            <li>Post the 30 days trial period you have to make the subscription payment in accordance with the subscription plan opted by you to continue use the application.</li>
            <li>You can also make subscription payment during the free trial period at a discount rate if any</li>
            <li>By submitting payment details, you confirm that you are authorising us to use those payment details for subscription payment.</li>
            <li>The subscription amount will include taxes as applicable by the government.</li>
            <li>The subscription period will be for a period of 1 year post the 30 days trial period</li>
            <li>The subscription being non-transferable, cannot be transferred to any other member or to any third party.</li>
            <li>The subscription will be auto renewed at the end of the subscription period on payment of renewal subscription fee at the then prevailing renewal subscription amount.</li>
            <li>You will have the option to port into a higher subscription plan by choosing the appropriate subscription plan option and payment of subscription amount.</li>
            <li>You may also cancel your subscription at any time post free trial period.</li>
            <li>The cancellation will be effective from the next subscription renewal date.</li>
            <li>Subscription once paid is non-refundable.</li>
            <li>The above terms & conditions has to be read in conjunction with the Privacy Policy & Terms of Use.</li>
          </ol>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="planDialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-center ">
      <v-dialog
        v-model="canclePlanDialog"
        width="500"
      >
        <v-card class="secure-modal plan-modalbox subsription-successful-modal cancel-subscription">
          <v-card-text class="proceed-cancel-box" v-if="is_active_key == 1">
            <v-card class="secure-modal">
            <v-card-title class="text-h5  ">
              How to cancel your subscription ?
               <v-card-actions class="close-icon">
                <v-btn
                  color="primary"
                  text
                  @click="canclePlanDialog = false"
                >
                  <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                </v-btn>
              </v-card-actions>
            </v-card-title>
            <v-card-text>
             We’re sorry that you wish to cancel. We’d like to hear from you for the reason for cancellation. You can write to us at cancel @nimeya.ai<br>
             As per subscription terms and conditions your cancellation will be effective {{trail_txt}}.<br>
             Till that time, you can continue to use the application.
            </v-card-text>
          </v-card>
           <v-card-actions>
              <v-btn class="blue-btn btn" @click="isProceedCancle"> PROCEED TO CANCEL 
              </v-btn>
            </v-card-actions>
          </v-card-text>
          <v-card-text v-if="is_active_key == 2">
              <v-card class="secure-modal">
              <v-card-title class="">
                 <v-card-actions class="close-icon">
                  <v-btn
                    color="primary"
                    text
                    @click="canclePlanDialog = false"
                  >
                    <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
                  </v-btn>
                </v-card-actions>
              </v-card-title>
              <v-card-text>
              You have successfully cancelled your subscription. Cancellation will be effective from {{expiry_date}}. Till that time you can use the application.<br>
              If you change your mind and continue to use the application, please check to the link to change status form CANCELLED to ACTIVE prior to subscription expiry date.
            </v-card-text>
            </v-card>
              <v-card-actions>
              <v-btn class="blue-btn btn" @click="isProceedActive"> CHANGE TO ACTIVE PLAN 
              </v-btn><br>
              <v-btn class="blue-btn btn"  @click="canclePlanDialog = false"> PROCEED </v-btn>
            </v-card-actions>
          </v-card-text>
          <v-card-text class="changed-status-box" v-if="is_active_key == 3">
            <span>
              The status of your subscription has been successfully changed to ACTIVE.<br>
              We thank you for continuing to use Nimeya.ai
            </span>
            <v-card-actions>
              <v-btn class="blue-btn btn" @click="isProceed"> PROCEED 
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { CANCEL_SUBSCRIPTION, UPDATE_PROFILE_DETAIL, GET_PLAN_DETAIL } from "../../store/actions.type";
import ApiService from "../../api/api.service";
import { isEmpty } from 'lodash';
   export default {
      data() {
        return {
          logo_image:process.env.VUE_APP_ROOT_ICONS_URL,
          status:null,
          is_current_plan:null,
          is_active_key: 1,
          get_plan_list: [],
          plan_type:'',
          expiry_date:'',
          expiry_day:'',
          is_trail_active:'',
          planDialog: false,
          canclePlanDialog:false,
          plan_id:null,
          currentplan:null,
          delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
          grace_period_text:null,
          app_status:null,
          trail_txt:null,
          payment_status:'',
          discountPercent:'',
          isGracePeriod:parseInt(localStorage.getItem("isGracePeriod"))
        }
      },
      created(){
        this.showPlanDetail()
      },
      methods:{
        changePlan(plan){
          if(plan == 0)
          {
            this.$loading(true);
            let cognito_idp = atob(localStorage.getItem('cognito_idp'));
            ApiService.setHeader();
            ApiService.post('change-plan-status',{
              aws_cognito_id: cognito_idp,
              plan_id: this.plan_id,
            }).then( (response) => {
              this.$loading(false);
              this.canclePlanDialog = true;
              this.is_active_key = 3;
              this.is_current_plan = 'CANCEL';
              this.status = 'ACTIVE';
              this.currentplan = 1;
            });
           
          }
          else{
            this.canclePlanDialog = true;
            this.is_active_key = 1;
          }
        },
        currentPlan(){

        },
        payNow(){
          this.$router.push({ name: "pricingPlan", params:  {} }).catch(()=>{});
        },
        isProceedCancle(){
          this.$loading(true);
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          ApiService.setHeader();
          ApiService.post('change-plan-status',{
            aws_cognito_id: cognito_idp,
            plan_id: this.plan_id,
          }).then( (response) => {
            this.$loading(false);
            this.is_active_key = 2;
            this.status = 'CANCELLED';
            this.is_current_plan = 'ACTIVATE';
            this.currentplan = 0;
          });
        },
        isProceedActive(){
          this.is_active_key = 3;
          this.status = 'ACTIVE';
          this.is_current_plan = 'CANCEL';
          this.currentplan = 0;
        },
        isProceed(){
          this.is_active_key = 1;
          this.canclePlanDialog = false;
        },
        showPlanDetail(){
          this.$loading(true);
          let payment_status = this.$store.getters.getInvestometerDetail.plan_status ? this.$store.getters.getInvestometerDetail.plan_status:'Free';
          this.payment_status = payment_status;
          this.plan_id = this.$store.getters.getInvestometerDetail.curr_plan_id
          this.app_status = this.$store.getters.getInvestometerDetail.app_status
          if(this.$store.getters.getInvestometerDetail.is_free_trail == 'yes')
          {
            this.trail_txt = 'after trial period';
          }
          else{
           this.trail_txt = 'from next renewal date';
          }
          if(this.app_status == 'grace_period'){
            // this.grace_period_text = this.$store.getters.getInvestometerDetail.grace_period_text
            this.grace_period_text = 'Your grace period will end soon Kindly make a payment to use the application continuously after end of grace period';
          }

          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          ApiService.setHeader();
          ApiService.post('get-user-plan',{
            aws_cognito_id: cognito_idp,
            type: 'yearly',
            plan_id: this.plan_id,
            plan_status:payment_status
          }).then( (response) => {
             this.$loading(false);
             this.discountPercent = response.data.discountPercent;
              this.get_plan_list = response.data.data;
              this.get_plan_list.forEach(element=>{
                if(element.is_plan_active == 1){
                  this.currentplan = element.cancelled_status;
                  this.status  = element.cancelled_status == 0 ? 'CANCELLED':'ACTIVE';
                  this.is_current_plan  = element.cancelled_status == 0 ? 'ACTIVATE':'CANCEL';
                  this.plan_id = element.plan_id;
                  this.expiry_date = element.plan_expire_by;
                  if(this.expiry_date=="")
                  {
                    this.expiry_date="Plan Expired"
                  }
                  this.expiry_day = element.remaining_free_days;
                  this.deactivated = element.deactivated;
                  this.is_trail_active = element.is_trail_period_active;
                  this.trail_days = element.trialDays;
                }
              })
              this.plan_type = response.data.curr_plan_type;
          }).catch( error =>{
              this.$loading(false);
          })
        },

      }
}
</script>